import {eyePose} from './StudioFilters';

// Enlarge coverage around fixed eye anchors rather than scaling the whole face.
// Fit mouth/jaw first; headwear rises independently above the eye band.
export function premiumFaceFit(landmarks,designChin){
 const pose=eyePose(landmarks),cos=Math.cos(pose.angle),sin=Math.sin(pose.angle);
 const localY=p=>(-(p.x-pose.x)*sin+(p.y-pose.y)*cos)/pose.distance;
 const jaw=landmarks.getJawOutline?.()||[];
 const valid=p=>p&&Number.isFinite(p.x)&&Number.isFinite(p.y);
 const measured=jaw.length===17&&jaw.every(valid)?localY(jaw[8]):NaN;
 const designMouth=designChin*.68;
 // Discard implausible tracking rather than enlarging a mask around an outlier.
 const chin=Number.isFinite(measured)&&measured>=1.1&&measured<=2.3?measured+.045:designChin;
 const lips=landmarks.getMouth?.()||[];
 const measuredMouth=lips.length>=12&&lips.every(valid)?lips.reduce((sum,p)=>sum+localY(p),0)/lips.length:NaN;
 const mouth=Number.isFinite(measuredMouth)&&measuredMouth>.45&&measuredMouth<chin-.2?measuredMouth:chin*.68;
 const eyeBand=.3;
 const fittedY=y=>y<=eyeBand?y:y<=designMouth?eyeBand+(y-eyeBand)*(mouth-eyeBand)/(designMouth-eyeBand):mouth+(y-designMouth)*(chin-mouth)/(designChin-designMouth);
 const mapX=x=>Math.abs(x)<=.5?x:Math.sign(x)*(.5+(Math.abs(x)-.5)*1.3);
 const mapY=y=>{
  if(y<-.3)return -.3+(y+.3)*1.19;
  if(y<=eyeBand)return y;
  return eyeBand+(fittedY(y)-eyeBand)*1.15;
 };
 return {pose,chin,mouth,mapX,mapY};
}
export function withPremiumFace(context,landmarks,designChin,draw){
 const {pose,mapX,mapY}=premiumFaceFit(landmarks,designChin);
 const pointArgs=args=>args.map((value,i)=>i%2?mapY(value):mapX(value));
 const adapted=new Proxy(context,{
  get(target,key){
   if(['moveTo','lineTo','quadraticCurveTo','bezierCurveTo'].includes(key))return (...args)=>target[key](...pointArgs(args));
   if(key==='ellipse')return (x,y,rx,ry,...rest)=>target.ellipse(mapX(x),mapY(y),Math.abs(mapX(x+rx)-mapX(x-rx))/2,Math.abs(mapY(y+ry)-mapY(y-ry))/2,...rest);
   const value=target[key];return typeof value==='function'?value.bind(target):value;
  },
  set(target,key,value){target[key]=value;return true;}
 });
 context.save();try{context.translate(pose.x,pose.y);context.rotate(pose.angle);context.scale(pose.distance,pose.distance);context.lineJoin='round';context.lineCap='round';context.lineWidth=.025;draw(adapted);}finally{context.restore();}
}
